import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-feature-list-custom-item',
  templateUrl: './feature-list-custom-item.component.html',
  styleUrls: ['./feature-list-custom-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureListCustomItemComponent {}
